import React, { useState } from "react"
import { Grid } from '@material-ui/core'

import withStyles from "@material-ui/core/styles/withStyles"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import CarouselArrow from './CarouselArrow'

import GalleryCarouselStyle from './galleryCarouselStyle'
import GalleryCardWithTitleSubtitleBottom from "./GalleryCardWithTitleSubtitleBottom"
import GalleryCardFullInfo from "./GalleryCardFullInfo"
import GalleryCard from "./GalleryCard"
import PlanCard from "./PlanCard"

const GalleryCarousel = ({classes, autoplay, type, infinite, data, dots, arrowColor, variableWidth, centerMode, centerPadding, arrowPos}) => {

    const [currentSlide, setCurrentSlide] = useState(0);

    const carouselCards = data && data.map((item, idx) => {

      if(type === 'galleryProject' && item){
        return (
          <GalleryCard key={idx} item={item}/>
        );
      } else if(type === 'planProject' && item){
        return (
          <PlanCard key={idx} isCurrentSlide={currentSlide === idx} item={item}/>
        );
      } else if(type === 'galleryTitleSubtitleProject' && item){
        return (
          <GalleryCardWithTitleSubtitleBottom key={idx} isCurrentSlide={currentSlide === idx} item={item}/>
        );
      } else if(type === 'galleryFullInfoProject' && item){
        return (
          <GalleryCardFullInfo key={idx} isCurrentSlide={currentSlide === idx} item={item}/>
        );
      } else {
          return null;
      }
    });

    
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));

    const settings = {
        className: classes.sliderContent,
        centerMode: (typeof centerMode == "undefined") ? false : centerMode,
        dots: dots,
        infinite: (typeof infinite == "undefined") ? true : infinite,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: (typeof centerPadding == "undefined") ? "0px" : centerPadding,
        autoplaySpeed: 3000,
        autoplay: (typeof autoplay == "undefined") ? true : autoplay,
        pauseOnDotsHover: true,
        variableWidth: (typeof variableWidth == "undefined") ? false : variableWidth,
        arrows: !matches,
        beforeChange: (prev, next) => {            
            setTimeout( () => { setCurrentSlide(next); }, 10 );			
        },
        customPaging: index => {
            return (
              <div className={index === currentSlide ? classes.activeDots : classes.customDots}/>
            )
        },
        nextArrow: <CarouselArrow arrowStyle={{right: arrowPos, top: '47.5%'}} direction='forward' color={arrowColor}/>,
        prevArrow: <CarouselArrow arrowStyle={{left: arrowPos, top: '47.5%'}} direction='back' color={arrowColor}/>
      };

      return (
        <div style={{width: '100%'}}>
          {carouselCards && carouselCards.length > 1 ?
            <Slider {...settings} className={`${(type === 'galleryProject' || type === 'galleryTitleSubtitleProject' || type === 'galleryFullInfoProject') && classes.sliderGallery} ${type === 'planProject' && classes.sliderPlan} ${type === 'galleryTitleSubtitleProject' && classes.sliderGalleryFixedWidth} ${type === 'galleryFullInfoProject' && classes.sliderFullInfo}`}>
              {carouselCards}
            </Slider>
            :
            <Grid className={`${type === 'planProject' && classes.planProjectSingleCard}`} style={{width: type !== 'planProject' && '100%', margin: 'auto'}}>
            {carouselCards}
            </Grid>
          }
        </div>
      );
}

export default withStyles(GalleryCarouselStyle)(GalleryCarousel)
